export default __webpack_public_path__ + "static/media/successMsg.dfe10ae7.svg";